import React from 'react';
import {imagePropsTitle, imageProps, limitTime} from './data';
import * as S from './style';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container, Image} from '../../../Components/Atom';
import {ContentTitle} from '../../../Components/Organism';
import {viewSize, colorPalette} from '../../../config';
import {expiredIMG} from '../../../config/images';
import styled from 'styled-components';

export const ExpiredImg = styled.img`
	width: 100%;
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
	}
`;

export const ExpiredText = styled.div`
	color: ${colorPalette.white};
	font-family: 'Gmarket';
	font-size: 35px;
	font-weight: 600;
	text-align: center;
	@media screen and (max-width: ${viewSize.mobile}) {
		font-size: 20px;
	}
`;

const Course = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회코스']} />
			<S.Container>
				{/* <ExpiredText>준비중입니다.</ExpiredText>
				<ExpiredImg src={expiredIMG} /> */}
				{/* <ContentTitle {...imageProps.title0} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course0} />
					</S.CardWrapper>
					<ContentTitle {...imageProps.title} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course} />
					</S.CardWrapper>
					<div style={{marginTop: '50px'}}></div>
					<ContentTitle {...imageProps.title2} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course2} />
					</S.CardWrapper>
					<div style={{marginTop: '50px'}}></div>
					<ContentTitle {...imageProps.title3} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course3} />
					</S.CardWrapper>
					<div style={{marginTop: '50px'}}></div>
					<ContentTitle {...imageProps.title4} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course4} />
					</S.CardWrapper> */}
				<S.ImgWrapper>
					<ContentTitle {...imageProps.title5} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course5} />
					</S.CardWrapper>
					<div style={{marginTop: '30px'}}></div>
					<S.YoutubeSection>
						{/* <S.YoutubeTitle>마라톤 코스 영상</S.YoutubeTitle> */}
						<S.YoutubeContainer>
							<iframe
								src='https://www.youtube.com/embed/IoJe3Con148?si=YyyotmskS1bJj_gZ'
								title='마라톤 코스 영상'
								allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
								allowFullScreen
							></iframe>
						</S.YoutubeContainer>
					</S.YoutubeSection>
				</S.ImgWrapper>

				{/* <S.CardWrapper>
					<CardSection {...limitTime} />
				</S.CardWrapper> */}
			</S.Container>
		</Container>
	);
};

export default Course;
